import { ofType } from 'redux-observable'
import { switchMap, map, takeUntil } from 'rxjs/operators'
import { ajax } from 'Utils'
import environment, { selfPayApi } from 'environments/environment'
import { Apis } from 'Redux/APIs'
import {
  REQUEST_CANCEL,
  FILTER_ENDOFDAY_REPORT,
  FILTER_APPOINTMENTLIST_REPORT,
  FILTER_COLLECTION_REPORT,
  ALL_USERS,
  PRIOR_REPORT,
  SELF_PAY_PATIENT_REPORT_REQUEST,
  SELF_PAY_PATIENT_EXPORT_REQUEST,
  CLEAR_SELF_PAY_EXPORT,
  SELF_PAY_PATIENT_REQUEST_CLAIM,
  CLEAR_SELF_PAY_CLAIM,
  SELF_PAY_PATIENT_REQUEST_CPT,
  CLEAR_SELF_PAY_CPT,
  PREVISIT_ESTIMATE_REPORT_REQUEST,
  PREVISIT_ESTIMATE_EXPORT_REQUEST,
  CLEAR_PREVISIT_ESTIMATE_EXPORT,
  PREVISIT_ESTIMATE_DOWNLOAD_REQUEST,
  CLEAR_PREVISIT_ESTIMATE_DOWNLOAD,
} from './reports.types'
import {
  allUsersRes,
  endOfDayReportResponse,
  filterAppointmentListRes,
  filterCollectionRes,
  getPrevisitEstimateSuccess,
  getPrevisitEstimateExportSuccess,
  getPrevisitEstimateDownloadSuccess,
  getSelfPayExportSuccess,
  getSelfPayPatientSuccess,
  priorReportRes,
  selfPayPatientClaimSuccess,
  selfPayPatientCPTSuccess
} from './reports.actions'

import { objectToUrl } from "Utils/ajax-utils";
const { baseUrl} = environment
const ReportsEpic = {}

ReportsEpic.getEndOfDayReport = (action$) =>
  action$.pipe(
    ofType(FILTER_ENDOFDAY_REPORT),
    switchMap((action) =>
      ajax({
        url: `${baseUrl}/${Apis.Reports_getEndOfDayReport}?fromDate=${action.payload.fromDate}&toDate=${action.payload.toDate}&locationIds=${action.payload.locationIds}&paymentTypes=${action.payload.paymentTypes}&providerIds=${action.payload.providerIds}&sortBy=${action.payload.sortBy}`,
        method: 'GET',
      }).pipe(
        map(
          (response) => endOfDayReportResponse(response),
          takeUntil(action$.pipe(ofType(REQUEST_CANCEL))),
        ),
      ),
    ),
  )
ReportsEpic.getAppointmentListReport = (action$) =>
  action$.pipe(
    ofType(FILTER_APPOINTMENTLIST_REPORT),
    switchMap((action) =>
      ajax({
        url: `${baseUrl}/${Apis.Reports_getAppointmentListReport}?fromDate=${action.payload.fromDate}&toDate=${action.payload.toDate}&locationIds=${action.payload.locationIds}&providerIds=${action.payload.providerIds}&sortBy=${action.payload.sortBy}`,
        method: 'GET',
      }).pipe(
        map(
          (response) => filterAppointmentListRes(response),
          takeUntil(action$.pipe(ofType(REQUEST_CANCEL))),
        ),
      ),
    ),
  )
ReportsEpic.getCollectionReport = (action$) =>
  action$.pipe(
    ofType(FILTER_COLLECTION_REPORT),
    switchMap((action) =>
      ajax({
        url: objectToUrl(
          `${baseUrl}/${Apis.Reports_getCollectionReport}/${action.payload.page}`,
          action.payload.params
        ),
        method: 'GET',
      }).pipe(
        map(
          (response) => filterCollectionRes(response),
          takeUntil(action$.pipe(ofType(REQUEST_CANCEL))),
        ),
      ),
    ),
  )
ReportsEpic.getAllUsers = (action$) =>
  action$.pipe(
    ofType(ALL_USERS),
    switchMap(() =>
      ajax({
        url: `${baseUrl}/${Apis.Reports_getAllUsers}`,
        method: 'GET',
      }).pipe(
        map(
          (response) => allUsersRes(response),
          takeUntil(action$.pipe(ofType(REQUEST_CANCEL))),
        ),
      ),
    ),
  )
ReportsEpic.priorReport = (action$) =>
  action$.pipe(
    ofType(PRIOR_REPORT),
    switchMap((action) =>
      ajax({
        url: `${baseUrl}/${Apis.Reports_priorReport}?providerId=${action.payload.provider}&facilityId=${action.payload.facility}`,
        method: "GET"
      }).pipe(
        map(
          (response) => priorReportRes(response),
          takeUntil(action$.pipe(ofType(REQUEST_CANCEL)))
        )
      ))
  )

ReportsEpic.getSelfPayPatient = (action$) =>
  action$.pipe(
    ofType(SELF_PAY_PATIENT_REPORT_REQUEST),
    switchMap((action) =>
      ajax({
        url: `${baseUrl}/${Apis.Self_Pay_Patient}/${action.payload.iclinicId}?offset=${action.payload.offset}&pageSize=${action.payload.pageSize}`,
        method: 'POST',
        body: JSON.stringify(action.payload),
      }).pipe(
        map((res) => getSelfPayPatientSuccess(res.response)),
        takeUntil(action$.pipe(ofType(REQUEST_CANCEL))), 
      ),
    ),
  )


ReportsEpic.getSelfPayExport = (action$) =>
  action$.pipe(
    ofType(SELF_PAY_PATIENT_EXPORT_REQUEST),
    switchMap((action) =>
      ajax({
        url: `${baseUrl}/${Apis.Self_Pay_Export}/${action.payload.btexportType}`,
        method: 'POST',     
        body: JSON.stringify(action.payload),      
      }).pipe(
        map((res) => getSelfPayExportSuccess(res.response)),
        takeUntil(action$.pipe(ofType(CLEAR_SELF_PAY_EXPORT))),
      ),
    ),
  )

ReportsEpic.selfPayPatientCPT = (action$) =>
  action$.pipe(
    ofType(SELF_PAY_PATIENT_REQUEST_CPT),
    switchMap((action) =>
      ajax({
        url: `${baseUrl}/${Apis.Self_Pay_CPT}/${action.payload.clinic_id}?claimId=${action.payload.claimId}`,
        method: 'GET',
      }).pipe(
        map((res) => selfPayPatientCPTSuccess(res.response)),
        takeUntil(action$.pipe(ofType(CLEAR_SELF_PAY_CPT))),
      ),
    ),
  )

ReportsEpic.getPrevisitEstimateReport = (action$) =>
  action$.pipe(
    ofType(PREVISIT_ESTIMATE_REPORT_REQUEST),
    switchMap((action) =>
      ajax({
        url: `${baseUrl}/${Apis.Reports_getEstimationReport}/${action.payload.clinicId}?offset=${action.payload.offset}&pageSize=${action.payload.pageSize}`,
        method: 'POST',
        body: JSON.stringify(action.payload.body),
      }).pipe(
        map((res) => getPrevisitEstimateSuccess(res?.response || res)),
        takeUntil(action$.pipe(ofType(REQUEST_CANCEL))),
      ),
    ),
  )

ReportsEpic.exportPrevisitEstimateReport = (action$) =>
  action$.pipe(
    ofType(PREVISIT_ESTIMATE_EXPORT_REQUEST),
    switchMap((action) =>
      ajax({
        url: `${baseUrl}/${Apis.Reports_exportEstimationReport}/${action.payload.clinicId}/export`,
        method: 'POST',
        body: JSON.stringify(action.payload.body),
        ...(action.payload.responseType ? { responseType: action.payload.responseType } : {}),
      }).pipe(
        map((res) => getPrevisitEstimateExportSuccess(res?.response || res)),
        takeUntil(action$.pipe(ofType(CLEAR_PREVISIT_ESTIMATE_EXPORT))),
      ),
    ),
  )

ReportsEpic.downloadPrevisitEstimateReport = (action$) =>
  action$.pipe(
    ofType(PREVISIT_ESTIMATE_DOWNLOAD_REQUEST),
    switchMap((action) =>
      ajax({
        url: `${baseUrl}/${Apis.Reports_downloadFile}?filePath=${action.payload}`,
        method: 'GET',
        responseType: 'blob',
      }).pipe(
        map((res) =>
          getPrevisitEstimateDownloadSuccess({
            response: res?.response || res,
            filePath: action.payload,
          }),
        ),
        takeUntil(action$.pipe(ofType(CLEAR_PREVISIT_ESTIMATE_DOWNLOAD))),
      ),
    ),
  )


export default ReportsEpic